import { render } from "./PremiumSection.vue?vue&type=template&id=8c466760&scoped=true"
import script from "./PremiumSection.vue?vue&type=script&lang=js"
export * from "./PremiumSection.vue?vue&type=script&lang=js"

import "./PremiumSection.vue?vue&type=style&index=0&id=8c466760&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c466760"]])

export default __exports__